import { ApolloError } from '@apollo/client/core';
import { ErrorResponse } from '@apollo/client/link/error';

const getFirstErrorCode = (error: ApolloError | ErrorResponse): string => {
  const firstErrorWithCode =
    error.graphQLErrors &&
    error.graphQLErrors.find((graphQLError) => graphQLError.extensions && graphQLError.extensions.code);

  return firstErrorWithCode && (firstErrorWithCode.extensions.code as string);
};

export default getFirstErrorCode;
